import { styled } from '@linaria/react';
import { mdiAlertCircle, mdiCheckCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import "./Forms.linaria.module.css!=!./Forms?./Forms.linaria.module.css?css=H4sIAAAAAAAAA61U226jMBR871estFqlleIIJ7Qh8LRv+7LfgHwFB1+I7QAp6r+vgJICaSpV2pdIZzyazJk5YuPg7qDCc9Eq1ICciSz3MQyCXwkVrpToEoOa4UJ4gE1zg3HJJqByPTAl9gRutAdOvLIYWqYSzxoPkBSZjgnTntlk8hegRKS44u+Kc/CdfDw7L/gFEKM90358vgOXiFKhM+BNGW/DsrkC2Hhv1ByTjPs4uI62DyVIplsDKiwjXhgdEyPPSn+YvXn5HH172DhIfSDgqf2/yjdxdvsswhygO1H2j5+Ck+76eVLt7jZU+FI2w54ORpnYthiRIrPmrCkgRhob2ww/bnf79Y9t2P3s9k+DZD0cIjaSJgPzZ0gQfw4SKTS73ukm3CXYWMossIiKs4unNXZdR7euomXTvc152T2kkM2EHjjRxzwwJsBEd3Hq/e44Iy/40A5rVMg+AqA4ATWyWujsqSMhr1ISpTXMqgueT+0i4pHtUsx1Zvh8aqfpPQfBSEcqLfBeV69tdwIxHHHcpNDUBT3ixTgIcaSEvMSrv0Z7x6xFfrVe/WGyYl4QtFqvfluB5GrtkHbAMSv4KHzEaWZzs7etEhrUgvo8Dj7s72UKdSOavJrlklnGdJfONZWDS6GJpLic2vGbInR/A1gaUoy0Kk91YTCv2orZzpt8v1IlKJVspOVBCi9haCRfjO2s23BuNEc8qosvC3SwpK+Hw8uyrTvLfbrKXeduJ0ru4FfaMz/fU6+O9YlEpr095reHf9LYPqgeBgAA"
export const StyledFormRoot = /*#__PURE__*/styled('article')({
  name: "StyledFormRoot",
  class: "s139m4uk",
  propsAsIs: false
});
export const StyledFormRow = /*#__PURE__*/styled('div')({
  name: "StyledFormRow",
  class: "s1dt0i1q",
  propsAsIs: false
});
export const SuccessMessageContainer = /*#__PURE__*/styled('div')({
  name: "SuccessMessageContainer",
  class: "s1s18gi2",
  propsAsIs: false
});
export const StyledWarningText = /*#__PURE__*/styled('span')({
  name: "StyledWarningText",
  class: "s1bgc6b9",
  propsAsIs: false
});
export const inputStyles = "atm_c8_w1gvyb atm_cs_bfngof atm_am_kb7nvz atm_bx_1owkdjb atm_jb_grho7r";
const checkmarkIconStyles = "atm_7l_1nxixhv atm_9s_1o8liyq atm_vh_nkobfv atm_h0_1y44olf";
export const StyledCheckmarkIcon = () => <Icon path={mdiCheckCircleOutline} size="20px" className={checkmarkIconStyles} />;
const errorIconStyles = "atm_7l_1haf8wk atm_9s_1o8liyq atm_vh_nkobfv atm_h0_1y44olf";
export const StyledErrorIcon = () => <Icon path={mdiAlertCircle} size="20px" className={errorIconStyles} />;
export const StyledSuccessMessage = /*#__PURE__*/styled('span')({
  name: "StyledSuccessMessage",
  class: "s1pdz996",
  propsAsIs: false
});
export const StyledErrorMessage = /*#__PURE__*/styled('span')({
  name: "StyledErrorMessage",
  class: "s3ipfs1",
  propsAsIs: false
});
export const ValidationMessageContainer = /*#__PURE__*/styled('section')({
  name: "ValidationMessageContainer",
  class: "vjwqc8o",
  propsAsIs: false
});
export enum FORM_PANE_STATES {
  landing = 'landing',
  success = 'Success',
  error = 'We encountered an error',
}